import { Component } from '@angular/core';
import { Router }    from '@angular/router';

import { DeveloperService }  from '../../services/developers/developer.service';

import { UserSearchComponent } from '../../users/search/user-search.component';

@Component({
  moduleId: module.id,
  selector: 'developer-search',
  templateUrl: '../../users/search/user-search.component.html',
  styleUrls: [ '../../users/search/user-search.component.css' ]
})

export class DeveloperSearchComponent extends UserSearchComponent {

  constructor(
    protected router: Router,
    protected developerService: DeveloperService) { super(router, developerService); }

  protected getDetailUrl(): string {

    return '/developer/';
  };

  protected getUserString(): string {

    return 'Developer';
  };
}


// WEBPACK FOOTER //
// ./src/app/developers/search/developer-search.component.ts